import propertyOrNull from '@99designs/utils/app/propertyOrNull';
import user from '../models/user';
import design from '../models/design';

export default {
    create,
    defaultProperties,
    fromJSON,
    isPersisted,
    equal,
};

function create(properties) {
    return Object.assign({}, defaultProperties(), properties);
}

function equal(obj1, obj2) {
    return obj1 && obj2 && obj1.id === obj2.id;
}

function isPersisted(obj) {
    return !!obj.id;
}

function defaultProperties() {
    return {
        id: null,
        message: null,
        createdAt: new Date().toString(),
        annotation: null,
        isDeleted: false,
        creator: null,
        design: null,
        designId: null, // questionable. Added to ease DesignStore changes
        links: {
            self: null,
            delete: null,
            edit: null,
        },

        permission: {
            canDelete: false,
            canEdit: false,
            secondsRemainingEdit: 0,
            secondsRemainingDelete: 0,
        },
    };
}

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    const defaults = defaultProperties();

    return {
        id: propertyOrNull(json._links.self, 'href'),
        designId: propertyOrNull(json._embedded.design, 'designId'),
        message: json.message,
        formattedMessage: json.formattedMessage,
        annotation:
            json.annotationX && json.annotationY
                ? { x: json.annotationX || null, y: json.annotationY || null }
                : null,
        isDeleted: json.isDeleted,
        links: {
            self: propertyOrNull(json._links.self, 'href'),
            edit: propertyOrNull(json._links.edit, 'href'),
            delete: propertyOrNull(json._links.delete, 'href'),
        },
        createdAt: json.createdAt,
        creator: user.fromJSON(json._embedded.creator),
        permission: Object.assign({}, defaults.permission, json._embedded.permission || {}),
        design: design.fromJSON(json._embedded.file),
    };
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/models/designComment.js